import React from 'react';

import Seo from '../ui/Seo';
import PageHero from '../sections/PageHero';
import TradeTicker from '../sections/TradeTicker';
import Pledge from '../sections/Pledge';
import StoryDeck from '../sections/StoryDeck';
import SectionHead from '../sections/SectionHead';
import Faqs from '../sections/Faqs';
import Cta from '../sections/Cta';

import ResidentialLighting from "../media/images/lighting-solutions/residential-lighting.jpg";
import CommercialLighting from "../media/images/lighting-solutions/commercial-lighting.jpg";
import LandscapeLighting from "../media/images/lighting-solutions/landscape-lighting.jpg";
import ParkingLotLighting from "../media/images/lighting-solutions/parking-lot-lighting.jpg";
import EmergencyLighting from "../media/images/lighting-solutions/emergency-lighting.jpg";
import SmartLighting from "../media/images/lighting-solutions/smart-lighting.jpg";

const content =
[
    {
        title: "Residential Lighting",
        text: "Transform your home with custom lighting designs that blend aesthetics and functionality. Our residential lighting solutions include LED upgrades, recessed lighting, and more.",
        imgSrc: ResidentialLighting,
        alt: "Residential Lighting - Smart Electric Solutions",
        focus: "50%",
    },
    {
        title: "Commercial Lighting",
        text: "Illuminate your business with energy-efficient and visually appealing lighting systems. From offices to retail spaces, we create lighting solutions tailored to your needs.",
        imgSrc: CommercialLighting,
        alt: "Commercial Lighting - Business Lighting Solutions",
        focus: "50%",
    },
    {
        title: "Landscape Lighting",
        text: "Enhance your outdoor spaces with durable and stylish landscape lighting. Improve safety, ambiance, and curb appeal with expertly designed solutions.",
        imgSrc: LandscapeLighting,
        alt: "Landscape Lighting - Outdoor Spaces",
        focus: "70%",
    },
    {
        title: "Parking Lot Lighting",
        text: "Ensure safety and visibility for your customers and employees with professional parking lot lighting. We provide installation, maintenance, and repairs.",
        imgSrc: ParkingLotLighting,
        alt: "Parking Lot Lighting - Business Safety",
        focus: "70%",
    },
    {
        title: "Emergency Lighting",
        text: "Comply with safety regulations and protect occupants with reliable emergency and exit lighting systems installed and maintained by our experts.",
        imgSrc: EmergencyLighting,
        alt: "Emergency Lighting - Safety Compliance",
        focus: "50%",
    },
    {
        title: "Smart Lighting Solutions",
        text: "Automate your lighting with smart control systems. Schedule, dim, or change colors remotely for ultimate convenience and energy savings.",
        imgSrc: SmartLighting,
        alt: "Smart Lighting Solutions - Modern Technology",
        focus: "50%",
    }
];

export default function LightingSolutions() {
    return (
        <>
            <Seo
                title="Lighting Solutions"
                description="Residential, commercial, smart, landscape, emergency and parking lot lighting designed and installed across South Florida."
                keywords="lighting design, smart lighting, landscape lighting, emergency lighting, parking lot lighting, commercial lighting, South Florida"
                path="/lighting-solutions"
                schema={{
                    '@type': 'WebPage',
                    name: 'Lighting Solutions',
                    description: 'Residential, commercial, smart, landscape, emergency and parking lot lighting designed and installed across South Florida.',
                    url: 'https://smartelectric.solutions/lighting-solutions'
                }}
            />

            <PageHero
                eyebrow="Systems"
                title="Lighting designed, not just installed."
                lead="Layout, colour temperature, control and code, decided before the first can is cut in. The difference between a lit room and a good one is all specification."
                backdrop={content[0].imgSrc}
                focus={`${content[0].focus} center`}
                crumbs={[{ label: 'Systems' }, { label: 'Lighting Solutions' }]}
            />

            <TradeTicker />

            <section className="section section--tight">
                <div className="shell">
                    <Pledge />
                </div>
            </section>

            <section className="section section--ruled">
                <div className="shell">
                    <SectionHead
                        eyebrow="What we do"
                        title="Every kind of light."
                        lead="Interior, exterior, architectural and life safety, on control systems that make sense to the people using them."
                    />
                </div>

                <div style={{ marginTop: 'clamp(2.5rem, 6vw, 4rem)' }}>
                    <StoryDeck items={content} />
                </div>
            </section>

            <Faqs />
            <Cta />
        </>
    );
}
